export const LOGIN_EMAIL = '/member/login/email'
export const ROOT_URL = '/'
